<template>
  <table>
    <tr>
      <td>选择日期：</td>
      <td>
        <el-date-picker style="width: 300px;"
                        v-model="datePicker.value"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="datePicker.pickerOptions" @change="change($event)">
        </el-date-picker>
      </td>
    </tr>
  </table>
</template>

<script>

import moment from "moment";

export default {
  name: "ElDatePickerWithOptions",
  props: {},
  data() {
    return {
      datePicker: {
        value: [moment(), moment()],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    }
  },
  methods: {
    change(value) {
      this.$emit('dateChange', value);
    }
  }
}
</script>

<style scoped>

</style>
